/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findPersonalizedReminders = (queryName = 'reminderQuery') => (
    gql`query ${queryName} (
        $brand: String!
        $environment: String!
        $user: UserSF!
        $isHoldoutEligible: Boolean!
        $resolveIdentity: Boolean!
    ) {
        reminderRecs(
            brand: $brand,
            environment: $environment,
            user: $user,
            isHoldoutEligible: $isHoldoutEligible
            resolveIdentity: $resolveIdentity
        ) {
            recipients{
                name,
                firstName,
                lastName,
                occasion,
                occasionCode,
                occasionDate,
                product{partNumber},
                isStaticReminder
            }
            isHoldout
            recipCount
        }
    }`
);

export default findPersonalizedReminders;
